__turbopack_context__.v({
  "container": "styles-module__DNnddG__container",
  "description": "styles-module__DNnddG__description",
  "errorHint": "styles-module__DNnddG__errorHint",
  "hint": "styles-module__DNnddG__hint",
});
